import React from "react";
import { pwdResetCheckUser, pwdResetUser } from "../../actions/userActions";
import { connect } from "react-redux";
import { Modal, Button, Alert, Form, FormCheck } from "react-bootstrap";
import { Form as ReactFinalForm, Field } from "react-final-form";
import { Helmet } from "react-helmet";
import { pageview } from "../../utils/googleAnalyticsUtils";
class PwdResetPassword extends React.Component {
  async componentDidMount() {
    pageview('Password Reset Password');
    const token = this.props.match.params.token;
    const userId = this.props.match.params.userId;
    await this.props.pwdResetCheckUser(token, userId);
  }

  checkConfirmPassword = (v, values) =>
    v && v == values.password ? undefined : "The passwords do not match";

  onSubmit = async (values) => {
    await this.props.pwdResetUser(
      this.props.match.params.token,
      this.props.match.params.userId,
      values.password
    );
  };

  required = (v) => (v ? undefined : "Required");
  maxLength = (max) => (v) =>
    v && v.length > max ? `Must be ${max} characters or less` : undefined;
  minLength = (min) => (v) =>
    v && v.length < min ? `Must be ${min} characters or more` : undefined;
  composeValidators =
    (...validators) =>
    (value) =>
      validators.reduce(
        (error, validator) => error || validator(value),
        undefined
      );

  render() {
    return (
      <div>
        <Helmet>
          <meta name="robots" content="noindex" />
        </Helmet>
        {this.props.isTokenvalid && (
          <div className="prp-container">
            <div className="prp-text-container">
              <p className="prp-text">Please enter the new password</p>
              <ReactFinalForm
                onSubmit={this.onSubmit}
                render={({
                  handleSubmit,
                  form,
                  submitting,
                  pristine,
                  values,
                }) => {
                  return (
                    <form onSubmit={handleSubmit}>
                      {this.props.error && (
                        <Alert variant="danger">
                          <p>{this.props.error}</p>
                        </Alert>
                      )}

                      <Field
                        name="password"
                        validate={this.composeValidators(
                          this.required,
                          this.minLength(8),
                          this.maxLength(50)
                        )}
                      >
                        {({ input, meta }) => (
                          <div>
                            <Form.Group>
                              <Form.Label>Password</Form.Label>
                              <Form.Control
                                {...input}
                                type="password"
                                placeholder="Password"
                                isInvalid={meta.touched && meta.error}
                              />

                              <Form.Control.Feedback type="invalid">
                                {meta.error}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </div>
                        )}
                      </Field>

                      <Field
                        name="confirmPassword"
                        validate={this.checkConfirmPassword}
                      >
                        {({ input, meta }) => (
                          <div>
                            <Form.Group>
                              <Form.Label>Confirm Password</Form.Label>
                              <Form.Control
                                {...input}
                                type="password"
                                placeholder="Confirm Password"
                                isInvalid={meta.touched && meta.error}
                              />

                              <Form.Control.Feedback type="invalid">
                                {meta.error}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </div>
                        )}
                      </Field>

                      <button
                        className="btn btn-warning"
                        style={{ marginTop: "15px" }}
                        type="submit"
                      >
                        Submit
                      </button>
                    </form>
                  );
                }}
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loading: state.userLogin.loading,
    error: state.userLogin.error,
    isTokenvalid: state.userPwdReset.isTokenvalid,
  };
};
export default connect(mapStateToProps, { pwdResetCheckUser, pwdResetUser })(
  PwdResetPassword
);
